import React from 'react';

import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { useCurrentActor } from 'components/contexts/CurrentActor';

export function Content({ folderName }) {
  const {
    division: {
      attributes: { singularRAMSName },
    },
  } = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'procore.fileDestination.components.modal.Confirmation',
  });

  return (
    <div className='tw-p-8'>
      <h4 className='tw-mb-4 tw-mt-0 tw-text-l tw-font-semibold tw-text-grey-900'>
        {i18nT('title')}
      </h4>
      <p>
        <Trans
          i18nKey='procore.fileDestination.components.modal.Confirmation.description'
          ns='components'
          tOptions={{ interpolation: { escapeValue: false } }}
          values={{ folderName, singularRAMSName }}
        />
      </p>
    </div>
  );
}

Content.propTypes = {
  folderName: PropTypes.string.isRequired,
};
